import { logError } from 'lib/sentry/logError';
import { MenuItem } from 'shared';

import {
  FocusAreaType,
  IGoal,
  useEditGoalFocusArea,
  useGoalQueryActions,
} from 'features/goal';

type TGoalFocusAreaMenuEditButton = {
  focusAreaId: string;
  title: string;
};

export const GoalFocusAreaMenuEditButton = ({
  focusAreaId,
  title,
}: TGoalFocusAreaMenuEditButton) => {
  const {
    cancelGoalQueries,
    getGoalQuery,
    invalidateGoalQuery,
    updateGoalQueryData,
  } = useGoalQueryActions();

  const { onEditFocusAreaClick } = useEditGoalFocusArea({
    focusAreaId,
    title,
    options: {
      onMutate: async ({
        title,
        focusAreaId,
      }: {
        title: string;
        focusAreaId: string;
      }) => {
        await cancelGoalQueries();

        const previousValue = getGoalQuery();

        updateGoalQueryData((oldData: IGoal) => {
          oldData.focusAreas = oldData.focusAreas.map((focusArea) =>
            focusAreaId === focusArea.focusAreaId
              ? { ...focusArea, title }
              : focusArea
          );
        });

        return { focusAreas: previousValue?.focusAreas };
      },
      onSettled: () => {
        invalidateGoalQuery();
      },
      onError: async (
        error: unknown,
        __: unknown,
        context: { focusAreas: FocusAreaType[] } | undefined
      ) => {
        if (!context?.focusAreas) {
          return;
        }

        updateGoalQueryData((oldData: IGoal) => {
          oldData.focusAreas = context.focusAreas;
        });

        logError(error);
      },
    },
  });

  return <MenuItem onClick={onEditFocusAreaClick}>Edit focus area</MenuItem>;
};
